import type { ReactElement } from "react";

import {
    StyledLeadsBaseContentContainer,
    StyledLeadsTabContent,
    StyledLeadsTableWrapper,
} from "app/pages/sales-intelligence/common-components/layout";
import { SearchResultsTableBoundary } from "app/pages/sales-intelligence/common-components/search-results-table";
import type { TabContentComponentProps } from "app/pages/sales-intelligence/common-components/tabbed-page-content";
import type { PageTabBase } from "app/pages/sales-intelligence/common-components/tabbed-page-content/types";
import { type LeadsType, SearchRowContainer } from "app/pages/sales-intelligence/modules/leads-search";
import { useIsLeadsPanelDataLoading } from "app/pages/sales-intelligence/modules/leads-search/hooks/useIsLeadsPanelDataLoading";
import { LeadsSearchFiltersContainer } from "app/pages/sales-intelligence/modules/leads-search-filters";

import LeadsSearchResultsTableContainer from "../SearchResultsTableContainer/LeadsSearchResultsTableContainer";
import TableActionsPanelContainer from "../table-actions-panel/TableActionsPanel/TableActionsPanelContainer";

type Props = TabContentComponentProps<PageTabBase<LeadsType>>;

const LeadsTabContentContainer = ({ tab, shouldRenderDeferredContent = true }: Props): ReactElement => {
    const isLeadsPanelDataLoading = useIsLeadsPanelDataLoading();

    return (
        <StyledLeadsTabContent data-automation="tab-content">
            <StyledLeadsBaseContentContainer>
                <LeadsSearchFiltersContainer isLoading={isLeadsPanelDataLoading || !shouldRenderDeferredContent} />
            </StyledLeadsBaseContentContainer>

            <StyledLeadsTableWrapper>
                <TableActionsPanelContainer />
                <SearchRowContainer />
                <SearchResultsTableBoundary shouldSuspend={!shouldRenderDeferredContent}>
                    <LeadsSearchResultsTableContainer tab={tab} />
                </SearchResultsTableBoundary>
            </StyledLeadsTableWrapper>
        </StyledLeadsTabContent>
    );
};

export default LeadsTabContentContainer;
